function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcaretDown = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "20",
    height: "32",
    viewBox: "0 0 20 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.75411 11.0769H17.6291C18.9666 11.0769 19.6354 12.6957 18.6916 13.6394L11.2541 21.0769C10.6666 21.6644 9.7166 21.6644 9.13535 21.0769L1.69161 13.6394C0.747855 12.6957 1.41661 11.0769 2.75411 11.0769Z",
    fill: "black"
  }));
});